import { useIsMobile } from "./History/utils";
import "./History/History.css";
import HistoryDesktop from "./History/HistoryDesktop";
import HistoryMobile from "./History/HistoryMobile";

const History = () => {
    const isMobile = useIsMobile();
    return isMobile ? <HistoryMobile /> : <HistoryDesktop />;
};

export default History;